import { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import api from "../lib/api";

export default function ImpersonationBanner() {
  const [name, setName] = useState("");
  const active = !!localStorage.getItem("if_impersonator");

  useEffect(() => {
    if (active) api.get("/auth/me").then((r) => setName(r.data.name || r.data.email)).catch(() => {});
  }, [active]);

  if (!active) return null;

  const back = async () => {
    const adminToken = localStorage.getItem("if_impersonator");
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/impersonate-exit`,
                  { method: "POST", headers: { Authorization: `Bearer ${adminToken}` } });
    } catch (e) { /* noop */ }
    localStorage.setItem("if_token", adminToken);
    localStorage.removeItem("if_impersonator");
    window.location.href = "/admin";
  };

  return (
    <div data-testid="impersonation-banner"
         className="fixed inset-x-0 bottom-0 z-[100] flex flex-wrap items-center justify-center gap-3 bg-amber-500 px-4 py-2.5 text-sm font-bold text-navy shadow-lg">
      <span className="flex items-center gap-2">
        <ShieldAlert className="h-4 w-4" /> Admin view — you are logged in as {name || "this account"}
      </span>
      <button onClick={back} data-testid="impersonation-exit-btn"
              className="rounded-full bg-navy px-4 py-1 text-xs font-bold text-white transition-colors hover:bg-express">
        Return to Admin
      </button>
    </div>
  );
}
